<template>
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef"></div>
    <div class="bar-rig">
      <div class="rig-one">
        <a-input-search v-model:value="searchForm.keyword" :loading="searchLoading" allowClear placeholder="姓名|电话|证件" @search="getTableList"> </a-input-search>
      </div>
      <div class="rig-group">
        <div class="group-one">
          <a-select v-model:value="searchForm.status" allowClear placeholder="上报状态" @change="getTableList()">
            <a-select-option :value="0">待上报</a-select-option>
            <a-select-option :value="1">上报中</a-select-option>
            <a-select-option :value="2">上报成功</a-select-option>
            <a-select-option :value="3">上报失败</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="rig-group">
        <div class="group-one">
          <a-select v-model:value="searchForm.JYZT" allowClear placeholder="经营状态" @change="getTableList()">
            <a-select-option :value="1">开业</a-select-option>
            <a-select-option :value="2">停业</a-select-option>
            <a-select-option :value="9">注销</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="rig-one-no-shadow">
        <a-button type="link" @click="handleReset">重置筛选</a-button>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
    :columns="columns"
    :dataSource="dataSource"
    :loading="searchLoading"
    :pagination="false"
    :scroll="{
      x: columns.length > 8 ? columns.length * 130 : 0,
      y: tableHeight,
    }"
    class="table"
    size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'status_text'">
        <div v-if="record.status == 3" class="f-c-red">
          {{ record.status_text }}
        </div>
        <div v-else-if="record.status == 2" class="f-c-green">{{ record.status_text }}</div>
        <div v-else>{{ record.status_text }}</div>
      </template>
      <template v-if="column.key == 'operate'">
        <a-button type="link" @click="openDetails(record, 2)">编辑</a-button>
        <a-button type="link" @click="openDetails(record, 1)">查看</a-button>
        <a-button type="link" @click="operSyn(record)">同步</a-button>
        <a-button v-if="record.JYZT != 1" class="f-c-green" type="link" @click="updateStatus(record.id, 1)">开业 </a-button>
        <a-button v-if="record.JYZT != 2" class="f-c-red" type="link" @click="updateStatus(record.id, 2)">停业 </a-button>
        <a-button v-if="record.JYZT != 9" class="f-c-red" type="link" @click="updateStatus(record.id, 9)">注销 </a-button>
      </template>
    </template>
  </a-table>

  <!-- 分页 -->
  <MyPagination :pageTotal="pageTotal" @onShowSizeChange="onShowSizeChange" @pageChange="pageChange" />

  <!-- 弹窗 -->
  <a-modal v-model:visible="visibleAdd" :title="formTitle" :width="'80%'" class="modal" @ok="confirmFun">
    <a-form ref="formRef" :label-col="{ span: 8 }" :model="addForm" :rules="rules">
      <a-row :gutter="24" class="row-box">
        <a-col :span="12">
          <a-form-item v-if="addForm.id" class="f-item" label="记录ID" name="id">
            <div v-if="isLook">{{ addForm.id }}</div>
            <a-input v-else v-model:value="addForm.id" disabled />
          </a-form-item>
          <a-form-item class="f-item" label="登记编号" name="JYZDJBH">
            <div v-if="isLook">{{ addForm.JYZDJBH }}</div>
            <a-input v-else v-model:value="addForm.JYZDJBH" disabled />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item class="f-item" label="经营者类型" name="JYZLX">
            <div v-if="isLook">{{ addForm.JYZLX_text }}</div>
            <a-radio-group v-else v-model:value="addForm.JYZLX">
              <a-radio :value="1">个人</a-radio>
              <a-radio :value="2">企业</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item class="f-item" label="经营者状态" name="JYZT">
            <div v-if="isLook">{{ addForm.JYZT_text }}</div>
            <a-radio-group v-else v-model:value="addForm.JYZT" disabled="true">
              <a-radio :value="1">开业</a-radio>
              <a-radio :value="2">停业</a-radio>
              <a-radio :value="9">注销</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <!--      个人-->
      <a-row v-if="addForm.JYZLX == 1" :gutter="24" class="row-box">
        <a-col :span="12">
          <a-form-item class="f-item" label="经营人姓名" name="GRJYXM">
            <div v-if="isLook">{{ addForm.GRJYXM }}</div>
            <a-input v-else v-model:value="addForm.GRJYXM" placeholder="请输入经营人姓名" />
          </a-form-item>
          <a-form-item class="f-item" label="经营人证件号码" name="GRJYSFZH">
            <div v-if="isLook">{{ addForm.GRJYSFZH }}</div>
            <a-input v-else v-model:value="addForm.GRJYSFZH" placeholder="请输入经营人证件号码" />
          </a-form-item>
          <a-form-item class="f-item" label="经营人联系电话" name="GRJYLXDH">
            <div v-if="isLook">{{ addForm.jyr_GRJYLXDHlxdh }}</div>
            <a-input v-else v-model:value="addForm.GRJYLXDH" placeholder="请输入经营人联系电话" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="所在区域：" name="province_name" style="margin-bottom: 10px !important">
            <div v-if="isLook">{{ addForm.province_name }}/{{ addForm.city_name }}/{{ addForm.area_name }}</div>
            <OwnAreaSelect v-else :placeholder="areaPlaceholder" class="areaSel" style="width: 100%" @changeArea="changeArea" />
          </a-form-item>
          <a-form-item label="详细地址：" name="address">
            <div v-if="isLook">{{ addForm.address }}</div>
            <a-textarea v-else v-model:value="addForm.address" :rows="2" placeholder="请输入详细地址" style="width: 100%"></a-textarea>
          </a-form-item>
        </a-col>
      </a-row>
      <!--      企业-->
      <a-row v-else :gutter="24" class="row-box">
        <a-col :span="12">
          <a-form-item class="f-item" label="企业名称" name="QYJYMC">
            <div v-if="isLook">{{ addForm.QYJYMC }}</div>
            <a-input v-else v-model:value="addForm.QYJYMC" placeholder="请输入企业名称" />
          </a-form-item>
          <a-form-item class="f-item" label="企业信用代码" name="QYJYXYDM">
            <div v-if="isLook">{{ addForm.QYJYXYDM }}</div>
            <a-input v-else v-model:value="addForm.QYJYXYDM" placeholder="请输入企业信用代码" />
          </a-form-item>
          <a-form-item label="单位所在区域：" name="qy_province_name" style="margin-bottom: 10px !important">
            <div v-if="isLook">{{ addForm.qy_province_name }}/{{ addForm.qy_city_name }}/{{ addForm.qy_area_name }}</div>
            <OwnAreaSelect v-else :placeholder="areaPlaceholder" class="areaSel" style="width: 100%" @changeArea="qychangeArea" />
          </a-form-item>
          <a-form-item label="企业详细地址：" name="qy_address">
            <div v-if="isLook">{{ addForm.qy_address }}</div>
            <a-textarea v-else v-model:value="addForm.qy_address" :rows="2" placeholder="请输入详细地址" style="width: 100%"></a-textarea>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item class="f-item" label="企业联系电话" name="QYJYLXDH">
            <div v-if="isLook">{{ addForm.QYJYLXDH }}</div>
            <a-input v-else v-model:value="addForm.QYJYLXDH" placeholder="请输入企业联系电话" />
          </a-form-item>
          <a-form-item class="f-item" label="法人姓名" name="QYJYFRXM">
            <div v-if="isLook">{{ addForm.QYJYFRXM }}</div>
            <a-input v-else v-model:value="addForm.QYJYFRXM" placeholder="请输入法人姓名" />
          </a-form-item>
          <a-form-item class="f-item" label="法人证件号码" name="QYJYFRSFZH">
            <div v-if="isLook">{{ addForm.QYJYFRSFZH }}</div>
            <a-input v-else v-model:value="addForm.QYJYFRSFZH" placeholder="请输入法人证件号码" />
          </a-form-item>
          <a-form-item class="f-item" label="法人联系电话" name="QYJYFRLXDH">
            <div v-if="isLook">{{ addForm.QYJYFRLXDH }}</div>
            <a-input v-else v-model:value="addForm.QYJYFRLXDH" placeholder="请输入联系联系电话" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import { createVNode, onMounted, reactive, toRefs, watch } from 'vue';
import { ChangZhouOperatorDetail, ChangZhouOperatorEdit, ChangZhouOperatorList, ChangZhouOperatorStatus, ChangZhouOperatorSyn } from '@/api/api';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import useUtils from '@/hooks/useUtils.js'; //工具库
import store from '@/store/pms/landlord/index'; //VUEX
import router from '@/router/index';
import OwnAreaSelect from '@/components/pms/landlord/AreaSelect/AreaSelect.vue';

export default {
  components: {
    OwnAreaSelect,
    // PlusOutlined,
    // CloseCircleOutlined,
    // AreaSelect,
  },
  setup() {
    let { imgCut, countTable } = useUtils();

    // 搜索
    let search = reactive({
      topDom: '',
      searchForm: {
        keyword: '',
        status: [],
        JYZT: [],
        start: 0,
        limit: store.getters.getPageSize,
      },
      searchLoading: false,
      // 重置
      handleReset() {
        search.searchForm.keyword = '';
        search.searchForm.status = [];
        search.searchForm.JYZT = [];
        table.getTableList();
      },
    });

    // 表格
    let table = reactive({
      editId: [],
      tableHeight: '',
      dataSource: [],
      columns: [
        { title: '记录ID', dataIndex: 'id', key: 'id', width: 100, isShow: true, align: 'center', ellipsis: true },
        {
          title: '门店ID',
          dataIndex: 'store_id',
          key: 'store_id',
          width: 100,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        { title: '门店名称', dataIndex: 'store_name', key: 'store_name', width: 150, align: 'center' },
        {
          title: '登记编号',
          dataIndex: 'JYZDJBH',
          key: 'JYZDJBH',
          width: 100,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '经营类型',
          dataIndex: 'JYZLX_text',
          key: 'JYZLX_text',
          width: 100,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'status_text',
          key: 'status_text',
          width: 100,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        { title: '备注', dataIndex: 'remark', key: 'remark', width: 200, isShow: true, align: 'center', ellipsis: true },
        {
          title: '最近同步时间',
          dataIndex: 'synTime_text',
          key: 'synTime_text',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '个人姓名',
          dataIndex: 'GRJYXM',
          key: 'GRJYXM',
          width: 100,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '个人身份证号',
          dataIndex: 'GRJYSFZH',
          key: 'GRJYSFZH',
          width: 180,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '个人联系电话',
          dataIndex: 'GRJYLXDH',
          key: 'GRJYLXDH',
          width: 130,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '个人居住地址',
          dataIndex: 'GRJYJZDZ',
          key: 'GRJYJZDZ',
          width: 200,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '企业经营者名称',
          dataIndex: 'QYJYMC',
          key: 'QYJYMC',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '企业经营者信用代码',
          dataIndex: 'QYJYXYDM',
          key: 'QYJYXYDM',
          width: 180,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '经营单位联系电话',
          dataIndex: 'QYJYLXDH',
          key: 'QYJYLXDH',
          width: 130,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '企业经营者地址',
          dataIndex: 'QYJYBGDZ',
          key: 'QYJYBGDZ',
          width: 250,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '法人姓名',
          dataIndex: 'QYJYFRXM',
          key: 'QYJYFRXM',
          width: 100,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '法人身份证号',
          dataIndex: 'QYJYFRSFZH',
          key: 'QYJYFRSFZH',
          width: 180,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '法人联系电话',
          dataIndex: 'QYJYFRLXDH',
          key: 'QYJYFRLXDH',
          width: 130,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '经营状态',
          dataIndex: 'JYZT_text',
          key: 'JYZT_text',
          width: 100,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '登记时间',
          dataIndex: 'DJSJ_text',
          key: 'DJSJ_text',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '注销时间',
          dataIndex: 'ZXSJ_text',
          key: 'ZXSJ_text',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '停业时间',
          dataIndex: 'stopTime_text',
          key: 'stopTime_text',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        { title: '操作', dataIndex: 'operate', key: 'operate', width: 250, fixed: 'right', align: 'center' },
      ],
      companyLogo: JSON.parse(sessionStorage.getItem('companyInfo') || '{}').logo || '',
      getTableList() {
        search.searchLoading = true;
        ChangZhouOperatorList({
          keyword: search.searchForm.keyword,
          JYZT: search.searchForm.JYZT,
          start: search.searchForm.start,
          limit: search.searchForm.limit,
          status: search.searchForm.status,
        })
          .then(res => {
            table.dataSource = res.data.list;
            pagination.pageTotal = res.data.count;
            search.searchLoading = false;
          })
          .catch(() => {
            search.searchLoading = false;
          });
      },
      goRouter(url, params = {}, tab = 1) {
        router.push({ path: url, query: { hid: params.id, tab: tab } });
      },
    });

    // 弹窗
    let modal = reactive({
      stationPlaceholder: '请选择所属地市',
      areaPlaceholder: '请选择区域',
      formTitle: '添加门店',
      visibleRoom: false,
      visibleAdd: false,
      visibleJoin: false,
      CompanyOta: [],
      loading: false,
      isLook: false,
      rules: {
        // JYZLX: [{required: true,message: "经营类型不能为空",trigger: "blur",}],
      },

      getInitData() {
        return {
          id: '',
          JYZDJBH: '',
          JYZLX: '',
          GRJYXM: '',
          GRJYSFZH: '',
          GRJYLXDH: '',
          province_id: '',
          city_id: '',
          area_id: '',
          province_name: '',
          city_name: '',
          area_name: '',
          address: '',
          GRJYJZDZ: '',
          QYJYMC: '',
          QYJYXYDM: '',
          QYJYLXDH: '',
          qy_province_id: '',
          qy_city_id: '',
          qy_area_id: '',
          qy_province_name: '',
          qy_city_name: '',
          qy_area_name: '',
          operatorCode: '',
          qy_address: '',
          QYJYBGDZ: '',
          QYJYFRXM: '',
          QYJYFRSFZH: '',
          QYJYFRLXDH: '',
          JYZT: '',
          DJSJ: '',
          status_text: '',
          JYZLX_text: '',
          JYZT_text: '',
        };
      },

      // 选择区域回调
      changeArea(params) {
        console.log(99999, params);
        if (params) {
          Object.assign(modal.addForm, params);
        }
        // modal.addForm.province_id = params.province_id;
        // modal.addForm.city_id = params.city_id;
        // modal.addForm.area_id = params.area_id;
        // modal.addForm.cityname = params.p_name + '/' + params.c_name;
      },
      qychangeArea(params) {
        if (params) {
          modal.addForm.qy_province_id = params.province_id;
          modal.addForm.qy_city_id = params.city_id;
          modal.addForm.qy_area_id = params.area_id;
          // modal.addForm.qy_cityname = params.province_name + '/' + params.city_name+ '/' + params.area_name;
        }
      },
      // 查看门店
      openDetails(e, type) {
        if (type == 1) {
          modal.isLook = true;
          modal.formTitle = '经营者信息';
        } else {
          modal.isLook = false;
          modal.formTitle = '修改经营者信息';
        }
        modal.addForm = modal.getInitData();
        modal.visibleAdd = true;
        ChangZhouOperatorDetail({
          id: e.id,
        }).then(res => {
          Object.keys(modal.addForm).forEach(i => {
            modal.addForm[i] = res.data[i];
          });
          modal.addForm.id = res.data.id;
          modal.addForm.status = res.data.status;
          if (res.data.cityname != '') {
            modal.stationPlaceholder = res.data.cityname;
          }
          if (res.data.province_id != '') {
            modal.areaPlaceholder = res.data.province_name + '/' + res.data.city_name + '/' + res.data.area_name;
          } else if (res.data.qy_province_id != '') {
            modal.areaPlaceholder = res.data.qy_province_name + '/' + res.data.qy_city_name + '/' + res.data.qy_area_name;
          } else {
            modal.areaPlaceholder = '请选择区域';
          }
        });
      },
      //搜索选项
      filterOption(input, option) {
        console.log(input);
        console.log(option);
        return option.lable.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      },
      //同步
      operSyn(e) {
        Modal.confirm({
          title: `是否同步上报数据？`,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            ChangZhouOperatorSyn({
              id: e.id,
            })
              .then(res => {
                message.success(res.msg);
                modal.modalLoading = false;
                table.getTableList();
              })
              .catch(() => {
                modal.modalLoading = false;
              });
          },
        });
      },
      //状态更新
      updateStatus(id, status) {
        let title = '是否停业?停业后经营数据不再上报';
        if (status == 1) {
          title = '是否恢复开业?';
        } else if (status == 9) {
          title = '是否注销?注销后经营数据不再上报';
        }
        Modal.confirm({
          title: title,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            ChangZhouOperatorStatus({
              id: id,
              JYZT: status,
            })
              .then(res => {
                message.success(res.msg);
                modal.modalLoading = false;
                table.getTableList();
              })
              .catch(() => {
                modal.modalLoading = false;
              });
          },
        });
      },
      rowData: '',
      addForm: {},
      country: [],
      formRef: '', //表单验证

      modalLoading: false,
      //确定
      confirmFun() {
        if (modal.addForm.id && modal.addForm.id > 0 && modal.isLook === false) {
          modal.handleEditSave();
        } else {
          modal.visibleAdd = false;
        }
      },
      //编辑
      handleEditSave() {
        if (modal.modalLoading) {
          return;
        }
        modal.formRef.validate().then(() => {
          modal.modalLoading = true;
          ChangZhouOperatorEdit(modal.addForm)
            .then(res => {
              message.success(res.msg);
              modal.visibleAdd = false;
              table.getTableList();
              modal.modalLoading = false;
            })
            .catch(() => {
              modal.modalLoading = false;
            });
        });
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableList();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableList();
      },
    });

    watch(
      () => store.state.ContentHeight,
      () => {
        table.tableHeight = countTable(search.topDom) - 80;
      }
    );

    onMounted(() => {
      table.getTableList();
      table.tableHeight = countTable(search.topDom) - 80;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.row-box {
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;

  .f-item {
    margin-bottom: 10px !important;
  }
}

:deep(.areaSel) {
  input::-webkit-input-placeholder {
    color: #262626;
  }

  input:-ms-input-placeholder {
    // IE 10 +
    color: #262626;
  }

  input:-moz-placeholder {
    // Firefox 4 -18
    color: #262626;
  }

  input::-moz-placeholder {
    // Firefox 19 +
    color: #262626;
  }
}
</style>
